import { BaseApiService } from '../base/BaseApiService';
import { ApiResponse } from '../../types/api';

export interface ProcessExcelResult {
  totalLinhasProcessadas: number;
  contratosAtualizados: number;
  linhasComMatch: number;
  linhasSemMatch: number;
  erros: number;
  errosDetalhados: ExcelProcessingError[];
  mensagens: string[];
}

export interface ExcelProcessingError {
  linhaExcel: number;
  idProduto?: string;
  cnpjCpf?: string;
  oferta?: string;
  mensagem: string;
  dadosLinha?: string;
}

export class ContractExcelImportService extends BaseApiService {
  private readonly basePath = '/v1/contracts/excel';

  /**
   * Faz upload e processa arquivo Excel com status de produtos para atualizar contratos
   * @param file Arquivo Excel (.xlsx ou .xls)
   * @param isValidated true = Excel de validados, false = Excel de não validados
   * @returns Resultado do processamento
   */
  async uploadAndProcessExcel(file: File, isValidated: boolean): Promise<ProcessExcelResult> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('isValidated', isValidated.toString());

    const response = await this.api.post<ApiResponse<ProcessExcelResult>>(
      `${this.basePath}/import`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return this.extractData(response);
  }
}

export const contractExcelImportService = new ContractExcelImportService();

